import { CustomerPostRequestBody, CustomerPostResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateCustomer = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = ({ name, businessAddress, businessType, createAsEntered }: CustomerPostRequestBody) =>
    client
      .post('customer', {
        json: {
          name: name.trim(),
          businessAddress,
          businessType,
          createAsEntered,
        },
      })
      .json<CustomerPostResponse>();
  const result = useMutation({
    mutationFn,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [...customerQueryKey._customer, 'list'] });
    },
  });
  return {
    ...result,
    createCustomerAsync: result.mutateAsync,
    createCustomerError: result.error,
    isCreateCustomerError: result.isError,
    isCreateCustomerSuccess: result.isSuccess,
  };
};
